import { logger } from '@empathy/logger';

export const Logger = logger.child('%cEmpathyAdapter',
  'background-color:#c50953;color:#ffffff;border-radius:3px;padding:3px 10px;font-weight:bold');
